const API = process.env.REACT_APP_API_BASE || 'http://localhost:5000'
export function makeImageUrl(x) {
  if (!x) return null
  if (/^https?:\/\//i.test(x)) return x
  return `${API}/api/Room/images/${encodeURIComponent(x)}`
}
